import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Spinner } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
// import { getVisitHistory } from 'services/salesperson-kpi/saleCustService';
import { search } from 'services/salesperson-kpi/myVisitsService';
import { BaseTableRQ } from 'components/common/models/BaseClass';
import { usePaginationBe } from 'hooks/useBeHandle';
import { joinDataMultiDropdown } from 'helpers/dropdownFuncHelper';
import MyVisitHisTable from './MyVisitHisTable';
import MyVisitHistoryFilter from './MyVisitHistoryFilter';
import MyVisitHisHeader from './MyVisitHisHeader';
import PropTypes from 'prop-types';
const MyVisitHistory = ({ isFromManagerPage = false }) => {
  const defaultRQ = { ...new BaseTableRQ(1, 10), isFromManagerPage };

  const [history, setHistory] = useState([]);
  const [total, setTotal] = useState(0);
  const [paging, setPaging] = useState({ ...defaultRQ });
  const [loading, setLoading] = useState(true);
  const [isFilter, setIsFilter] = useState(false);
  const [filter, setFilter] = useState({});

  // --- Load initial data ---
  useEffect(() => {
    loadVisitHistory(defaultRQ);
  }, []);

  // --- Load visit history ---
  const loadVisitHistory = rq => {
    setLoading(true);
    search(rq)
      .then(res => {
        if (res) {
          setHistory(res.items || []);
          setTotal(res.total || 0);
        }
      })
      .catch(err => console.error(err))
      .finally(() => {
        setLoading(false);
        setPaging(rq);
      });
  };

  // --- Pagination control ---
  const { gotoPage, nextPage, previousPage } = usePaginationBe(
    paging,
    total,
    loadVisitHistory
  );

  // --- Toggle filter ---
  const toggelFilter = () => {
    setIsFilter(!isFilter);
  };

  // --- Filter change ---
  const handleChange = (field, value) => {
    setFilter(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // --- Filter submit ---
  const handleSubmit = () => {
    const rq = mapRQData(filter);
    if (isFilter) {
      loadVisitHistory({ ...defaultRQ, ...rq });
    } else {
      loadVisitHistory({ ...defaultRQ });
    }
  };

  const mapRQData = data => {
    if (!data) return {};
    let mapRq = { ...data };
    if (data?.visitDate && data?.visitDate instanceof Date) {
      mapRq.visitDate = data?.visitDate?.toISOString();
    }
    mapRq.saleIds = joinDataMultiDropdown(data?.sale);
    mapRq.customerTypeId = data?.customerType?.value;
    console.log(mapRq);
    return mapRq;
  };

  return (
    <>
      <PageHeader
        title="Visit History"
        description="View all visits related to this customer"
        className="mb-3"
      />

      <Row className="g-3 mb-3">
        <Col lg={12}>
          <Card className="p-3">
            <MyVisitHisHeader
              style={{ padding: '10px' }}
              toggelFilter={() => toggelFilter()}
            />
            {isFilter && (
              <Col
                lg={12}
                style={{
                  padding: '0px',
                  paddingTop: '10px',
                  paddingBottom: '8px'
                }}
              >
                <MyVisitHistoryFilter
                  displayOption={{
                    showHeader: true,
                    showFooter: true,
                    col: '6'
                  }}
                  style={{
                    paddingBottom: '10px',
                    maxHeight: '250px',
                    overflowY: 'auto',
                    Border: 'none'
                  }}
                  handleChange={handleChange}
                  formData={filter}
                  handleSubmit={handleSubmit}
                  isFromManagerPage={isFromManagerPage}
                />
              </Col>
            )}
            {loading ? (
              <div className="text-center p-4">
                <Spinner animation="border" />
              </div>
            ) : history.length === 0 ? (
              <p className="text-center m-3 text-muted">
                No visit history found.
              </p>
            ) : (
              <>
                <MyVisitHisTable
                  data={history}
                  paging={paging}
                  total={total}
                  nextPage={nextPage}
                  previousPage={previousPage}
                  gotoPage={gotoPage}
                />
              </>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
};

MyVisitHistory.propTypes = { isFromManagerPage: PropTypes.bool };
export default MyVisitHistory;
